export default __webpack_public_path__ + "a009bd0d49cc697e6aeb0babb5db3253.png";